import { requestGet, requestPost } from '@/common/request';

export default {
  async marketingPlanSelectorData(query) {
    return await requestGet('/marketingPlan/selectorData', query);
  },
  async marketingPlanCreate(query) {
    return await requestPost('/marketingPlan/create', query);
  },
  async marketingPlanDetail(query) {
    return await requestGet('/marketingPlan/detail', query);
  },
  async marketingPlanUpdate(query) {
    return await requestPost('/marketingPlan/update', query);
  },
};
